import fetchGetQuotes from '@lyra/core/api/private/fetchGetQuotes'
import { QuoteResultSchema } from '@lyra/core/api/types/private.get_quotes'
import { LyraAuthHeaders } from '@lyra/core/constants/api'

export const fetchRfqQuotes = async (
  subaccountId: number,
  authHeaders: LyraAuthHeaders
): Promise<QuoteResultSchema[]> => {
  try {
    const response = await fetchGetQuotes(
      {
        subaccount_id: subaccountId,
      },
      authHeaders
    )
    if ('error' in response) {
      return []
    }
    const quotes: QuoteResultSchema[] = response.result.quotes
    return quotes
  } catch (error) {
    console.error('Error fetching quotes:', error)
    return []
  }
}
